<template>
    <layout>
         <div class="row">
            <div class="col-sm-8 col-xs-offset-2">

                <!-- Inspections block -->
                <div :class="[working ? 'block-opt-refresh' : '', 'block', 'block-rounded']">
                    <div class="block-header">
                        <h4 class="block-title">Contact Us
                            <span class="pull-right"  style="color:green;"> <i class="fa fa-lg fa-phone"> </i> {{this.contactPhone}}</span>
                        </h4>
                    </div>

                    <div v-if="result === null">
                        <div class="block-content">
                            <p class="alert alert-info"><strong>Got a question?</strong>  Fill out the below form and we will get back to you as soon as we can.</p>

                            <form v-on:submit.prevent="attempt" class="form-horizontal push-30-t push-30" novalidate>
                            <div class="row">
                                    <wc-input class="col-sm-6" label="First Name" v-model="user.contact.first_name" :neverDirty="true"></wc-input>
                                    <wc-input class="col-sm-6" label="Last Name" v-model="user.contact.last_name" :neverDirty="true"></wc-input>
                                    <wc-input class="col-sm-6" label="Email Address" v-model="user.email" :neverDirty="true"></wc-input>
                                    <wc-input class="col-sm-6" label="Phone Number" v-model="user.contact.phone" :neverDirty="true"></wc-input>

                                    <label class="col-sm-12">Message</label>
                                    <wc-textarea class="col-sm-12" v-model="message" :neverDirty="true"></wc-textarea>
                                </div>


                                        <!-- <p class="text-center remove-margin-b">Don't have an account? <router-link to="register">Register Now</router-link></p> -->
                            </form>




                        </div>



                        <div class="block-content block-content-full bg-gray-lighter text-center">
                            <div class="row">
                                <!-- -<div class="col-xs-6">
                                    <p class="">Urgent?  <i class="fa fa-lg fa-phone"> 1-800-SHAVEDICE</i> </p>
                                </div> -->
                                <div class="col-xs-12 pull-right">
                                    <button class="btn btn-block btn-primary"  v-on:click.prevent="sendMessage"><i class="fa fa-envelope push-5-r"></i> Send</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else-if="result === true" class="block-content block-content-full row">

                        <div class="col-xs-12" style="height:50px;"></div>
                        <div class="text-center text-muted">
                            <h3>Success!</h3>
                            <div class="item item-2x item-circle bg-gray-lighter push-20-t push-20">
                                <i class="fa fa-birthday-cake"></i>
                            </div>
                            <p>Message received!  We will get back to you shortly. <!--Click the button below to get started making a new inspection.--></p>
                            <p/>
                        </div>
                        <div class="col-xs-12" style="height:50px;"></div>
                    </div>

                    <div v-else class="block-content block-content-full row">

                        <div class="col-xs-12" style="height:50px;"></div>
                        <div class="text-center text-muted">
                            <div class="item item-2x item-circle bg-gray-lighter push-20-t push-20">
                                <i class="icon-ghost"></i>
                            </div>
                            <p>We couldn't deliver your message.  Please reach out to us by calling {{this.contactPhone}}</p>
                            <p/>
                        </div>
                        <div class="col-xs-12" style="height:50px;"></div>
                    </div>

                    <div class="block-footer">
                    </div>
                </div>

            </div>
        </div>


    </layout>
</template>

<script>
    import roleMixin from '../../mixins/role-mixins.js';

    export default {
        mixins: [ roleMixin ],
        name: 'help',
        components: {
            layout: require('../layouts/default.vue'),
            wcInput: require('../elements/forms/wc-input.vue'),
            wcTextarea: require('../elements/forms/wc-textarea.vue')
        },
        data () {
            return {
                user: this.$schema.map('user'),
                message: '',
                working: false,
                result: null,
                contactPhone: '1-800-492-6216'
            }
        },

        methods: {

            getUser () {
                let self = this;
                this.working = true;

                this.axios.get('users/me' + '?include=contact').then((response) => {
                    self.working = false;
                    self.user = response.data;
                });
            },

            sendMessage () {
                this.working = true;

                this.axios.post('help', { user:this.user, message: this.message}).then((response) => {
                    this.working = false;

                    this.result = true;


                }).catch((e) => {
                    this.working = false;
                    this.result = false;
                });;
            }
        },

        created () {
            this.getUser();
        },

        validations: {
        },
    };
</script>



// WEBPACK FOOTER //
// help.vue?47c92133